export { default as getExtendedProperty } from './util/getExtendedProperty';
export { default as getIsFolderHiddenProperty } from './util/getIsFolderHiddenProperty';
export {
    default as getSourceWellKnownFolderTypeProperty,
} from './util/getSourceWellKnownFolderTypeProperty';
